import React, { useEffect } from 'react'
import { useRouteError } from 'react-router-dom'
import { ErrorFallback } from './ErrorFallback'
import { logAppError } from '../../../helpers/errorHelper'

export const RouteErrorElement = (): JSX.Element => {
   const error = useRouteError()

   useEffect(() => {
      logAppError(error)
   }, [error])

   return <ErrorFallback error={error} />
}
